import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useLogoutMutation } from 'services/users';
import { useAppSelector } from 'app/hooks';
import { useGetUserDataQuery } from 'services/users';

import { StyledLinkList, StyledLink } from 'ui/navigation/StyledLinkList';



export const HomepageNavigation = () => {

  const { t } = useTranslation();
  const [logout, { isSuccess }] = useLogoutMutation();
  const navigate = useNavigate();

  useGetUserDataQuery();
  
  const user = useAppSelector(state => state.users?.user);

  useEffect(() => {
    if(isSuccess) {
      navigate('/');
    }
  }, [isSuccess]);

  const submitLogout = () => {
    logout({});
  }

  return (
    <>
      <StyledLinkList align="left">
        <li>
          <a href="/#about">About</a>
        </li>
        <li>
          <a href="/#features">Features</a>
        </li>
        <li>
          <a href="/#cases">Cases</a>
        </li>
        <li>
          <a href="pricing/">Pricing</a>
        </li>
        <li>
          <a href="/#contact">Contact</a>
        </li>
      </StyledLinkList>
      <StyledLinkList align="right">
        <li>
          {user?.id ? (
            <StyledLinkList align="right">
              <li>
              <StyledLink href="/backoffice/">
                {t('Backoffice')}
              </StyledLink>
              </li>
              <li>
              <StyledLink onClick={submitLogout}>
                {t('Logout')}
              </StyledLink>
              </li>
            </StyledLinkList>
          ) : (
            <StyledLink href="/sign-in/">
              {t('Sign in')}
            </StyledLink>
          )}
        </li>
      </StyledLinkList>
    </>
  );
}